import Typography from '@mui/material/Typography'
import { useWrapperStore } from '../../store/storeWrapper'

export const GuestMode = () => {
    const { isTempUser } = useWrapperStore((state) => state)
    return (
        <>
            {isTempUser && (
                <Typography
                    variant="caption2"
                    sx={{
                        transform: ' translate(-50%,0)',
                        left: '50%',
                        color: '#fff',
                        top: '-4px',
                        position: 'absolute',
                        height: '20px',
                        padding: '2px 10px',
                        background: '#006CFD',
                        borderRadius: '8px',
                        zIndex: 99,
                    }}>
                    Гостевой режим
                </Typography>
            )}
        </>
    )
}
